module.exports = __webpack_public_path__ + "static/media/domecq_academy.093dedb8.png";